import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"email-2, envelope"} maskId="square-filled-radius-0-stroke-1-IconEmail2"><path d="M22 4H2V6.44891L12 11.511L22 6.4489V4Z" fill="currentColor"/><path d="M22 7.5697L12 12.6318L2 7.5697V20H22V7.5697Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEmail2;
